<template>
  <div>
    <div class="all-users-page test-class">
      <h1 class="page-header color-1-100">Topics list</h1>
    </div>
    <div class="content-section">
      <div class="data-list-heading">
        <div class="data-list-statusbar">
          <div class="data-list-statusbar__contains data-list-statusbar__block">{{ tags.length }} topics</div>
        </div>
        <a href="#"
           v-on:click.prevent="displayAddForm()"
           class="data-list-add"
           :class="[{ 'data-list-add__close': addFormDisplay}]"
           tabindex="-1">Add new topic</a>
      </div>
      <div class="categories-add-form" v-if="addFormDisplay">
        <div class="form-group form-group-half">
          <div class="form-element">
            <label for="input-category-name" class="form-label color-2-63">Topic name</label>
            <input type="text"
                   id="input-category-name"
                   class="form-control form-control__input background-1-10-disabled  border-1-10-disabled"
                   v-model="newTag.name"/>
          </div>
          <div class="form-element">
            <label for="input-category-icon" class="form-label color-2-63">Topic icon</label>
            <input type="text"
                   id="input-category-icon"
                   class="form-control form-control__input background-1-10-disabled  border-1-10-disabled"
                   v-model="newTag.icon"/>
          </div>
          <div class="form-element">
            <input type="checkbox"
                   id="new-featured"
                   class="form-control form-control__checkbox background-1-10-disabled  border-1-10-disabled"
                   v-model="newTag.featured"/>
            <label for="new-featured" class="form-label color-2-63">Featured</label>
          </div>
        </div>
        <div class="form-group form-group-half">
          <div class="form-element">
            <label for="textarea-category-desc" class="form-label color-2-63">Topic description</label>
            <textarea
                    name="category-desc"
                    id="textarea-category-desc"
                    cols="30"
                    rows="5"
                    style="height: 140px;"
                    v-model="newTag.description"
                    class="form-control form-control__textarea">
              </textarea>
          </div>
        </div>
        <div class="clearfix"></div>
        <div class="update-data update-data__details">
          <a href="#" v-on:click.prevent="closeAddForm()" class="cancel-edit background-2-7 color-2-100 cancel-edit-details">Cancel</a>
          <a href="#" v-on:click.prevent="createTag()" class="save-edit background-1-100 color-2-100 save-edit-details">Create topic</a>
        </div>
        <hr class="add-form-delimiter" />
      </div>
      <div class="data-list-body">
        <table class="table table-data">
          <thead>
          <tr>
            <th class="cellpadding tag-list-body__head_id table-head-ceil id-column">ID</th>
            <th class="categories-list-search-col text-left tag-list-body__head_search table-head-ceil">
              <div class="table-search-wrap">
                <div class="wrap-input">
                  <input
                          v-model="searchString"
                          type="search"
                          class="table-search"
                          placeholder="Search in topics..." />
                </div>
                <div class="wrap-search-icon"></div>
              </div>
            </th>
            <th colspan="2" class="cellpadding tag-list-body__head_actions table-head-ceil">Actions</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="tag in updatedTags">
            <td class="text-center cellpadding text-center" v-if="tag.type === 'show'">
              {{tag.id}}
            </td>
            <td class="cellpadding" v-if="tag.type === 'show'">{{tag.name}}</td>
            <td class="cellpadding text-center action-column" v-if="tag.type === 'show'">
              <button
                      type="button"
                      class="table-crud-btn icon-btn edit-btn"
                      @click="showEditionForm(tag.id)">
                <span class="table-tooltip">Edit</span>
              </button>
            </td>
            <td class="cellpadding text-center action-column" v-if="tag.type === 'show'">
              <button
                      type="button"
                      class="table-crud-btn icon-btn delete-btn"
                      @click="removeTag(tag.id)">
                <span class="table-tooltip">Remove</span>
              </button>
            </td>
            <td colspan="4" v-if="tag.type === 'edit'" class="edit-row">
              <div class="wrap-edit-form" style="display: block;">
                <div class="row-edit-form" style="max-width: unset; margin-bottom: 32px; display: flex;">
                  <div class="wrap-title-input" style="max-width: 140px;">
                    <div class="form-element" style="margin: 0 !important;">
                      <input type="checkbox"
                             id="edit-featured"
                             class="form-control form-control__checkbox background-1-10-disabled  border-1-10-disabled"
                             v-model="tag.featured"/>
                      <label for="edit-featured" class="form-label color-2-63">Featured</label>
                    </div>
                  </div>
                  <div class="wrap-title-input" style="max-width: unset;">
                    <input type="text"
                           class="form-control form-control__input background-1-10-disabled  border-1-10-disabled"
                           placeholder="Name"
                           v-model="tag.name">
                  </div>
                  <div class="wrap-title-input" style="max-width: unset;">
                    <input type="text"
                           class="form-control form-control__input background-1-10-disabled  border-1-10-disabled"
                           placeholder="Icon"
                           v-model="tag.icon">
                  </div>
                  <div class="wrap-desc-textarea" style="max-width: unset;">
                    <textarea name="desc-textarea"
                              cols="10"
                              rows="3"
                              class="form-control form-control__textarea"
                              placeholder="Description"
                              v-model="tag.description"></textarea>
                  </div>
                </div>
                <div class="wrap-table-control-panel" style="width: 100%; text-align: right;">
                  <button type="button" @click="discardСhanges(tag.id)">Cancel</button>
                  <button type="button" @click="editTag(tag.id)">Save</button>
                </div>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'tags-list',
  data () {
    return {
      infMsgTitle: '',
      infMsgDescription: '',
      infMsgClass: '',
      tags: [],
      updatedTags: [],
      contentAutoloadInfo: {
        curPage: 1,
        numPages: 1,
        locked: false
      },
      newTag: {
        name: '',
        isActive: 1,
        featured: 0,
        description: '',
        icon: ''
      },
      disableAPI: false,
      searchString: '',
      addFormDisplay: false
    }
  },
  methods: {
    ...mapActions([
      'getTags',
      'setInformationMsg',
      'clearConfAction',
      'initConfAction'
    ]),
    displayAddForm () {
      this.addFormDisplay = !this.addFormDisplay
    },
    closeAddForm () {
      this.addFormDisplay = !this.addFormDisplay
    },
    search () {
      if (!this.filter.search) {
        this.contentInfo.typeAutoLoad = 'allContent'
        this.fetchAllContentByScroll(1, 20)
        return
      }
      this.contentInfo.typeAutoLoad = 'searchContent'
      this.fetchSearchContent()
    },
    fetchSearchContent () {
      if (!this.filter.search) return
      let queryString = `${api.URLS.search}`
      Object.keys(this.filter).forEach((item) => {
        let value = this.filter[item]
        if (value && typeof (value) === 'string') {
          queryString += `&search=${value}`
        }
        if (value !== null && typeof (value) === 'object' && value.length) {
          let subString = ''
          value.forEach((it) => {
            subString += `&${item}=${it.value}`
          })
          queryString += subString
        }
      })
      if (this.contentType.length) queryString += '&contentType=' + this.contentType[0].value
      this.$http.get(`${queryString}`, api.headersAuthSettings)
        .then((res) => {
          let resData = res.body.data.items
          if (!resData) {
            this.articles = []
            return
          }
          this.articles = resData
        })
        .catch((err) => console.error(err))
    },
    removeTag (id) {
      this.initConfAction({
        actionId: id,
        actionName: 'removeTagById'
      })
    },
    removeTagConfirmed (id) {
      let self = this
      let thisTag = this.updatedTags.find((tag) => tag.id === id)
      this.getTags()
      this.$http.delete(api.URLS.tag + '/' + id, api.headersAuthSettings)
          .then((res) => {
            self.infMsgTitle = thisTag.name + ' topic was successfully deleted.'
            self.infMsgDescription = 'Please note all actions are being logged.'
            self.infMsgClass = 'success'
            self.setInformationMsg({
              isShown: true,
              title: self.infMsgTitle,
              text: self.infMsgDescription,
              className: self.infMsgClass
            })
            for (let i = 0; i < self.tags.length; i++) {
              if (self.tags[i].id === id) {
                self.tags.splice(i, 1)
                break
              }
            }
          })
          .catch((err) => console.log(err))
    },
    handleScroll (event) {
      let scrollHeight = Math.max(
        document.body.scrollHeight, document.documentElement.scrollHeight,
        document.body.offsetHeight, document.documentElement.offsetHeight,
        document.body.clientHeight, document.documentElement.clientHeight)
      let fullScrolledValue = window.pageYOffset + window.innerHeight

      if (fullScrolledValue > scrollHeight - 200) {
        this.fetchAllContentByScroll(++this.contentAutoloadInfo.curPage, 20)
      }
    },
    fetchAllContentByScroll (page, limit) {
      if (this.contentAutoloadInfo.locked || this.contentAutoloadInfo.curPage > this.contentAutoloadInfo.numPages) return
      this.contentAutoloadInfo.locked = true
      this.$http.get(api.URLS.tags1 + '?limit=' + limit + '&page=' + page, api.headersAuthSettings)
        .then((res) => {
          this.contentAutoloadInfo.curPage = res.body.current_page_number
          this.contentAutoloadInfo.numPages = Math.ceil(res.body.total_count / limit)
          this.tags = [...this.tags, ...res.body.items]
          this.contentAutoloadInfo.locked = false
        })
        .catch((err) => {
          this.contentAutoloadInfo.locked = false
          console.log(err)
        })
    },
    createTag () {
      if (this.disableAPI) return
      if (!this.newTag.name) return
      let formData = new FormData()
      Object.keys(this.newTag).forEach((fieldName) => {
        if (typeof this.newTag[fieldName] === 'string' || typeof this.newTag[fieldName] === 'number') {
          formData.append('tag[' + fieldName + ']', this.newTag[fieldName])
        }
        if (typeof this.newTag[fieldName] === 'boolean') {
          formData.append('tag[' + fieldName + ']', this.newTag[fieldName] || '0')
        }
        if (typeof this.newTag[fieldName] === 'object') {
          this.newTag[fieldName].forEach((item, i) => {
            formData.append('tag[' + fieldName + '][' + i + ']', item.value)
          })
        }
      })
      this.disableAPI = true
      this.$http.post(api.URLS.tag, formData, api.headersAuthSettings)
        .then((res) => {
          this.disableAPI = false
          this.infMsgTitle = this.newTag.name + ' topic was successfully added.'
          this.infMsgDescription = 'Please note all actions are being logged.'
          this.infMsgClass = 'success'
          this.setInformationMsg({
            isShown: true,
            title: this.infMsgTitle,
            text: this.infMsgDescription,
            className: this.infMsgClass
          })
          this.tags.push(res.body)
          this.newTag.name = ''
          this.newTag.description = ''
          this.newTag.icon = ''
          this.newTag.featured = 0
          this.addFormDisplay = false
        })
        .catch((err) => {
          this.disableAPI = false
          console.log(err)
        })
    },
    showEditionForm (id) {
      for (let tag of this.updatedTags) {
        if (tag.type === 'edit') tag.type = null
        if (tag.id === id && tag.type === null) {
          tag.type = 'edit'
        }
      }
    },
    discardСhanges (id) {
      for (let tag of this.updatedTags) {
        if (tag.id === id && tag.type === 'edit') {
          tag.type = null
        }
      }
    },
    editTag (id) {
      if (this.disableAPI) return
      let tag = this.updatedTags.find((tag) => tag.id === id && tag.type === 'edit')
      let formData = {
        tag: {
          name: tag.name,
          description: tag.description,
          icon: tag.icon,
          isActive: tag.isActive,
          featured: tag.featured || 0
        }
      }
      this.disableAPI = true
      this.$http.put(api.URLS.tag + '/' + id, formData, api.headersAuthSettings)
        .then((res) => {
          this.disableAPI = false
          this.discardСhanges(id)
          for (let i = 0; i < this.updatedTags.length; i++) {
            if (this.updatedTags[i].id === id && this.updatedTags[i].type === 'show') {
              let updatedData = res.body
              updatedData.type = 'show'
              this.updatedTags[i] = updatedData
              break
            }
          }
          let infMsg = 'Topic has been successfully updated'
          this.setInformationMsg({text: infMsg, className: 'success'})
        })
        .catch((err) => {
          this.disableAPI = false
          console.log(err)
        })
    }
  },
  computed: {
    ...mapGetters([
      'getConfData'
    ]),
    filteredTags () {
      return this.tags.filter((tag) => tag.name.toLowerCase().indexOf(this.searchString.toLowerCase()) > -1)
    }
  },
  watch: {
    filteredTags: function () {
      let updatedTags = []
      this.filteredTags.forEach((tag, i, arr) => {
        tag.type = 'show'
        updatedTags.push(tag)
        updatedTags.push({
          type: null,
          id: tag.id,
          name: tag.name,
          description: tag.description,
          icon: tag.icon,
          isActive: tag.isActive,
          featured: tag.featured
        })
      })
      this.updatedTags = updatedTags
    },
    'getConfData.actionConfirmed' (value) {
      let actionName = this.getConfData.actionName
      if (value) {
        switch (actionName) {
          case 'removeTagById':
            this.removeTagConfirmed(this.getConfData.actionId)
            this.clearConfAction()
            break
        }
      }
    }
  },
  mounted () {
    this.fetchAllContentByScroll(1, 20)
    this.getTags()
  },
  created () {
    document.title = 'Topics list | Clear Assured'
    if (window.ga) {
      window.ga('set', 'contentGroup1', 'ADMINISTRATION_AREA')
      window.ga('send', 'pageview', {
        'page': location.pathname,
        'location': location.href,
        'title': document.title
      })
    }
  },
  destroyed () {}
}
</script>

<style src='@/assets/scss/components/table.scss' lang='scss' scoped />



// WEBPACK FOOTER //
// TagsList.vue?dd1af2a0